import React from "react";
import "../../style/Footer.css";
import Navbar from "react-bootstrap/Navbar";
import ButtonsLike from "./ButtonsLike";
import ButtonsCompartir from "./ButtonsCompartir";
import ButtonsSiguiente from "./ButtonsSiguiente";
import ButtonsCobrar from "./ButtonsCobrar";
import { useAppContext } from "../../AppContext";

export default function Footer() {
  const { globalState } = useAppContext({});

  return (
    <>
      {globalState.step !== "7" && globalState.step !== "6" &&(
        <Navbar className="additional-navbar">
          {globalState.step === "1" ? (
            <ButtonsLike />
          ) : globalState.step === "2" ? (
            <ButtonsSiguiente />
          ) : globalState.step === "3" ? (
            <></>
          ) : globalState.step === "4" ? (
            <ButtonsCobrar />
          ) : (
            <></>
          )}
        </Navbar>
      )}
    </>
  );
}
